import { render, staticRenderFns } from "./UserLanguage.vue?vue&type=template&id=2118633e&scoped=true"
import script from "./UserLanguage.vue?vue&type=script&lang=ts"
export * from "./UserLanguage.vue?vue&type=script&lang=ts"
import style0 from "./UserLanguage.vue?vue&type=style&index=0&id=2118633e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2118633e",
  null
  
)

export default component.exports